import setting from "../package.json";

const { homepage } = setting;

const config = {
  /**
   * URL webu
   */
  URL: `${window.location.origin}${homepage}/`,
  /**
   * produkcni URL
   */
  PROD_URL: `https://webapp.cz.dhl.com${homepage}/`,
  /**
   * URL API
   */
  BASE_URL:
    process.env.NODE_ENV === "development"
      ? //"https://localhost:5002/"
        "https://webapp-test.srv.cz.dhl.com/register/api"
      : `${window.location.origin}${homepage}/api`,
  /**
   * čas pro http požadavek [ms]
   */
  TIMEOUT: process.env.NODE_ENV === "development" ? 60000 : 20000,
  /**
   * cas zobrazeni zprávy uživateli
   */
  MESSAGE_DURATION: 5,
  SENTRY_URL: `https://5973e2757c7a4668a7e54507c9edded8@${
    process.env.NODE_ENV === "development"
      ? "sentry.srv.cz.dhl.com"
      : window.location.hostname
  }/41`,
  TERMS_DOCUMENT_URL: "http://www.dhl.com/freight/podminky",
  TERMS_DOCUMENT_URL_LOCAL: `${process.env.PUBLIC_URL}/documents/cz-general-conditions-for-transport.pdf`,
};

export default config;
